
<div class="progressIndicator" [class.d-none]="!showLoader">
    <div class="progressIndicatorInnerWrapper">
        <div class="loader"></div>
        <p>Loading</p>
    </div>
  </div>